import { render, staticRenderFns } from "./BaseInfoCard.vue?vue&type=template&id=c0c11164&scoped=true&"
import script from "./BaseInfoCard.vue?vue&type=script&lang=js&"
export * from "./BaseInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./BaseInfoCard.vue?vue&type=style&index=0&id=c0c11164&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c11164",
  null
  
)

export default component.exports